import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function CheckStreet() {
  const { isAuthenticated, account } = useSelector((state) => state.auth);

  if (isAuthenticated && account?.contactDetail
    && (account.contactDetail.streetId === null || account.contactDetail.streetId === undefined)) {
    return <Navigate to="/street-selection" />;
  }
}

export default CheckStreet;
